import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchConfiguration } from '@app/api'

export const getConfigurationThunk = createAsyncThunk(
  'configuration',
  fetchConfiguration
)
